import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '../views/index.vue'
import { useScreenStore } from '@/stores/index.js'
const routes = [
	{
		path: '/',
		redirect: '/home'
	},
	{
		path: '/home',
		name: 'home',
		component: HomeView,
		meta: { title: "home" },
	},
	{
		path: '/tenders/biddingInformation',
		name: 'biddingInformation',
		component: () => import('@/views/tenders/BiddingInformation.vue'),
		meta: { title: "biddingInformation" },
	},
	{
		path: '/tenders/BiddingInfoPostponeAnnouncement',
		name: 'BiddingInfoPostponeAnnouncement',
		component: () => import('@/views/tenders/BiddingInfoPostponeAnnouncement.vue'),
		meta: { title: "BiddingInfoPostponeAnnouncement" },
	},
	{
		path: '/tenders/historybiddinginformation',
		name: 'historybiddinginformation',
		component: () => import('@/views/tenders/historybiddinginformation.vue'),
		meta: {
			title: "historybiddinginformation",
			// requiresAuth: true // 需要密码验证
		},
	},
	// {
	// 	path: '/tenders/keyAcquiredItem',
	// 	name: 'keyAcquiredItem',
	// 	component: () => import('@/views/tenders/keyAcquiredItem.vue'),
	// 	meta: {
	// 		title: "keyAcquiredItem",
	// 		requiresAuth: false // 需要密码验证
	// 	},
	// },
	{
		path: '/tenders',
		name: 'tenders',
		component: () => import('@/views/tenders/tenders.vue'),
		meta: {
			title: "tenders",
			requiresAuth: false // 需要密码验证
		},
	},
	{
		path: '/tenders/bidddingDetails',
		name: 'bidddingDetails',
		component: () => import('@/views/tenders/bidddingDetails.vue'),
		meta: {
			title: "bidddingDetails",
			requiresAuth: false // 需要密码验证
		},
	},

	{
		path: '/news',
		name: 'news',
		component: () => import('@/views/news/news.vue'),
		meta: { title: "news" },
	},
	// {
	// 	path: '/details/:category/:id/:time',
	// 	name: 'details',
	// 	component: () => import('@/views/news/details.vue'),
	// 	props: true,
	// 	meta: { title: "details" },
	// },
	// {
	// 	path: '/details2/:id',
	// 	name: 'details2',
	// 	component: () => import('@/views/news/details2.vue'),
	// 	props: true,
	// 	meta: { title: "details2" },
	// },
	{
		path: '/aboutUs',
		name: 'aboutUs',
		component: () => import('@/views/about/aboutUs.vue'),
		meta: { title: "aboutUs" },
	}, 
	{
		path: '/aboutUs/project',
		name: 'project',
		component: () => import('@/views/about/projects.vue'),
	},
	// {
	// 	path: '/aboutUs/scholarship',
	// 	name: 'scholarship',
	// 	component: () => import('@/views/about/scholarship.vue'),
	// },
	// {
	// 	path: '/aboutUs/socialResponsibility',
	// 	name: 'socialResponsibility',
	// 	component: () => import('@/views/about/socialResponsibility.vue'),
	// },
	// {
	// 	path: '/aboutUs/hsee',
	// 	name: 'hsee',
	// 	component: () => import('@/views/about/hsee.vue'),
	// },
	// {
	// 	path: '/contactUs',
	// 	name: 'contactUs',
	// 	component: () => import('@/views/contactUs/contactUs.vue'),
	// 	meta: { title: "contactUs" },
	// },
	{
		path: '/recruitment',
		name: 'recruitment',
		component: () => import('@/views/recruitment/recruitment.vue'),
		meta: { title: "recruitment" },
	},
	{
		path: '/passwordDialog', 
		name: 'passwordDialog',
		component: () => import('@/views/publicComponent/passwordDialog.vue'),
		meta: { title: "contactUs" },
	},
	// news 新闻详情
	{
		path: '/newsdetails/:id',
		name: 'newsdetails',
		component: () => import('@/views/article/news/details.vue'),
		props: true,
		meta: { title: "newsdetails" },
	},
	// 关于我们 详情
	{
		path: '/aboutdetails/:id',
		name: 'aboutdetails',
		component: () => import('@/views/article/about/details.vue'),
		props: true,
		meta: { title: "aboutdetails" },
	},
	// 招标详情
	{
		path: '/tendersdetails/:id',
		name: 'tendersdetails',
		component: () => import('@/views/article/tenders/details.vue'),
		props: true,
		meta: { title: "tendersdetails" },
	},
	// 招聘详情、其他详情
	{
		path: '/details/:id',
		name: 'details',
		component: () => import('@/views/article/details.vue'),
		props: true,
		meta: { title: "details" },
	},
	// 其他路由...
	{
		path: '/:pathMatch(.*)*', // 匹配所有路径
		name: 'NotFound',
		component: () => import('@/components/404.vue'),
	}


]
// meta: {
// //通过这个值可以隐藏头部和底部
//   headerHide: true,
//   footerHide: true
// }

const router = createRouter({
	// mode: 'hash',
	history: createWebHistory('/'),
	base: '/', // 确保这是相对路径
	// history: createWebHashHistory(),
	routes: routes,
	scrollBehavior (to, from, savedPosition) {
		// 始终滚动到顶部
		return { top: 0 }
		// 或者平滑滚动（兼容性需验证）
		//return { top: 0, behavior: 'smooth' }
	}
})
// 全局路由守卫
router.beforeEach(async (to, from, next) => {
	if (to.meta.requiresAuth) {
		const savedPassword = localStorage.getItem('tender_access_password')
		if (savedPassword && savedPassword === '123456') {
			next()
		} else {
			router.push("/passwordDialog");
			next()
		}
	} else {
		next()
	}
})
export default router
